// extracted by mini-css-extract-plugin
module.exports = {"container":"i_a9","option-1":"i_bA","option-2":"i_bB","option-3":"i_bC","headline":"i_bD"};